import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { AdminAnnouncements } from '@/components/AdminAnnouncements'

export const Route = createFileRoute('/_auth/operations/announcements')({
  component: AnnouncementsRoute,
})

function AnnouncementsRoute() {
  return <AdminAnnouncements showAddButton showBackButton={true} />
}
